import React from 'react';
import { styled } from '@material-ui/styles';
import { Button, Slide, Icon, Snackbar, SnackbarContent } from '@material-ui/core';

export const isDev = _ => process.env.NODE_ENV === 'development';

export const isObjEmpty = o => Object.keys(o).length === 0;

export const RoutesNames = Object.freeze({
    EXAMS: 'exams',
    TRAINERS: 'trainers',
    ADMINS: 'admins',
    CLIENTS: 'clients',
    PROFILE: 'profile',
});

export const ExamsFilter = Object.freeze([
    {value: 'unmarked-exams',
     iconComp: <Icon style={{color: '#f7b500'}}> error_outline </Icon>},
    {value: 'failed-exams',
     iconComp: <Icon style={{color: '#e02020'}}> close </Icon>},
    {value: 'passed-exams',
     iconComp: <Icon style={{color:'#40db9e'}}> check </Icon>},
    {value: 'flaged-exams',
     iconComp: <Icon style={{color: '#f65421'}}> flag </Icon>},
]);

export const ExamStatus = Object.freeze({
    REJECTED: 0,
    APPROVED: 1,
    PENDING: 2,
    READY_TO_START: 3,
    UPLOADING: 4,
    FINISHED: 5,
    LOCKED: 6,
    // INAPPROPRIATE: 7,
    // TECHNICAL_ISSUE: 8,
});

export const ReportStatus = Object.freeze({
    INAPPROPRIATE: 0,
    TECHNICAL_ISSUE: 1,
});

export const DogGender = Object.freeze({
    UNKNOWN: 0,
    MALE: 1,
    FEMALE: 2,
    OTHER: 3,
});

export const BottomMessage = ({ open, close, message }) => {
    return (
	<Snackbar
	anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
	open={open}
	autoHideDuration={2500}
	onClose={close}>
	<SnackbarContent
	message={ <span> {message} </span> }/>
	</Snackbar>
    );
};

export const DialogCancelButton = styled(Button)({
    color: '#f62152',
});

export const DialogGrayCancelButton = styled(Button)({
    color: '#808080',
});

export const DialogAcceptButton = styled(Button)({
    color: '#1ce3b6',
});

export const Transition = React.forwardRef((props, ref) => {
    return <Slide direction="up" ref={ref} {...props} />;
});

export const isEmailValid = (email) => {
    const re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    return re.test(String(email).toLowerCase());
};

export const isPasswordValid = (password) => {
    return password.length >= 6;
};

export const isNameValid = (name) => {
    return name.length >= 2;
};
